import { AngularFirestore } from "@angular/fire/firestore";
import * as globalFirebase from 'firebase/app'

type QuizSelection = {
    videoProfileId: string;
    candidateSelected: 'Trump' | 'Biden';
    isCorrect: boolean;
}

type QuizVideoSelection = {
    videoProfileId: string;
    videoUrl: string;
    candidateSelected: 'Trump' | 'Biden';
    isCorrect: boolean;
}

const METADATA_ID = 'ZfgcLC8Dbwq7kWOMjCgf';

let answerCounter = 0;

export const saveQuizSelection = (firestore: AngularFirestore, selection: QuizSelection) => {
    const isNewUser = answerCounter == 0;
    const increment = globalFirebase.default.firestore.FieldValue.increment(1);
    firestore.collection('metadatas').doc(METADATA_ID).update({
        answers: increment
    });
    if (selection.isCorrect) {
        firestore.collection('metadatas').doc(METADATA_ID).update({
            correctAnswers: increment
        });
    }
    if (isNewUser) {
        firestore.collection('metadatas').doc(METADATA_ID).update({
            totalUsers: increment
        });
    }
    answerCounter += 1;
    return firestore.collection('quiz-selection').add(selection);
}

export const saveQuizVideoSelection = (firestore: AngularFirestore, selection: QuizVideoSelection) => {
    return firestore.collection('quiz-video-selection').add(selection);
}

export const fetchQuizStats = (firestore: AngularFirestore) => {
    return firestore.collection('metadatas').doc(METADATA_ID).get().toPromise();
}